<template>
    <div v-if="Object.values(validAttributes).length">
        <template>
            <!--Desktop Filters-->
            <v-expansion-panel v-if="$vuetify.breakpoint.mdAndUp" v-model="expanded" expand class="elevation-0">
                <v-expansion-panel-content
                    v-for="(attributeValues, attributeType) in validAttributes"
                    expand-icon="keyboard_arrow_right"
                    class="transparent bordered-filter"
                    :key="attributeType"
                >
                    <template v-slot:header>
                        <v-layout row wrap align-center ma-0>
                            <v-flex xs2 class="attribute-filter-icon">
                                <v-img
                                    v-if="getAttributeTypeIcon(attributeType)"
                                    :src="getAttributeTypeIcon(attributeType)"
                                    contain
                                    width="25"
                                    height="25"
                                />
                            </v-flex>
                            <v-flex xs10 class="attribute-filter-title">
                                <div class="body-2">
                                    {{ getAttributeName(attributeType) }}
                                </div>
                            </v-flex>
                        </v-layout>
                    </template>

                    <v-card flat class="transparent">
                        <v-card-text class="pa-0 px-2">
                            <attribute-type-filter
                                :attribute-type-name="attributeType"
                                :attributeValues="attributeValues"
                                :readonly="loading"
                                :attributeType="getAttributeByIndexname(attributeType)"
                                :selected-values="selectedFiltersLists[attributeType]"
                                @valueSelect="setAttributeValue(attributeType, $event.attributeValue, $event.value)"
                                :initialAmountAttributeValues="initialAmountAttributeValues"
                                :additionalAmountAttributeValues="additionalAmountAttributeValues"
                            />
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <!--Mobile Filters-->
            <template v-else>
                <template v-for="(attributeValues, attributeType) in validAttributes">
                    <div class="attribute-type" :key="'mobile-title-' + attributeType">
                        <v-card
                            flat
                            class="transparent pa-2 d-flex align-center"
                            @click="openDrawer(attributeType)"
                        >
                            <div>
                                <div class="title attribute-type-title">{{getAttributeName(attributeType)}}</div>
                                <div v-if="Object.keys(selectedFiltersLists[attributeType]).length > 0"
                                     class="primary--text">
                                    {{Object.keys(selectedFiltersLists[attributeType]).join(', ')}}
                                </div>
                            </div>

                            <v-spacer></v-spacer>

                            <span class="text-xs-right">
                            <v-icon large>keyboard_arrow_right</v-icon>
                        </span>
                        </v-card>

                        <v-navigation-drawer
                            v-model="attributesDrawers[attributeType]"
                            fixed
                            app
                            temporary
                            right
                            flat
                            :width="windowWidth"
                            :style="{top: drawerOffset + 'px'}"
                        >
                            <v-container fluid>
                                <a class="text-underline search-filters-back" @click.prevent="closeDrawer(attributeType)">
                                    {{ 'back' | translation }}
                                </a>

                                <v-divider></v-divider>

                                <attribute-type-filter
                                    :attribute-type-name="attributeType"
                                    :attributeValues="attributeValues"
                                    :readonly="loading"
                                    :attributeType="getAttributeByIndexname(attributeType)"
                                    :selected-values="selectedFiltersLists[attributeType]"
                                    @valueSelect="setAttributeValue(attributeType, $event.attributeValue, $event.value)"
                                    :initialAmountAttributeValues="initialAmountAttributeValues"
                                    :additionalAmountAttributeValues="additionalAmountAttributeValues"
                                />
                            </v-container>
                        </v-navigation-drawer>
                    </div>
                </template>
            </template>
        </template>
    </div>
</template>

<style>
    .v-expansion-panel__container--active > .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon {
        transform: rotate(90deg);
    }
</style>

<script>
    import {mapState, mapGetters} from 'vuex';
    import Vue from 'vue';
    import SearchResults from './SearchResults';
    import AttributeTypeFilter from './components/AttributeFilters/AttributeTypeFilter';

    const searchFiltersModuleName = 'SearchFilters';

    export default {
        name: searchFiltersModuleName,
        components: {
            AttributeTypeFilter,
        },
        props: {
            searchResults: {},
            drawerOffset: {
                default: 0,
            },
            internalDrawerState: Boolean,
        },
        data() {
            let attributesDrawers = {};
            if (this.attributes) {
                for (let attributeType of Object.keys(this.attributes)) {
                    attributesDrawers[attributeType] = false;
                }
            }

            return {
                windowWidth: window.innerWidth,
                attributesDrawers,
                expanded: [],
                opened: {},
            };
        },
        computed: {
            ...mapState(SearchResults.name, [
                'products',
                'lastSearchParams',
                'loading',
            ]),
            ...mapGetters(SearchResults.name, [
                'searchConfig',
            ]),
            ...mapGetters(searchFiltersModuleName, [
                'getAttributeByIndexname',
            ]),
            attributes() {
                return this.products && this.products.facets ? this.products.facets.attributes : {};
            },
            initialAmountAttributeValues() {
                return this.searchConfig('searchAttributeAmountInit');
            },
            additionalAmountAttributeValues() {
                return this.searchConfig('searchAttributeAmountAdded');
            },
            filtersStatus() {
                const result = {};
                Object.keys(this.attributes).forEach(attributeType => {
                    const attributeValues = this.attributes[attributeType];

                    if (!result[attributeType]) {
                        result[attributeType] = {};
                    }

                    attributeType = attributeType.replace('attribute_', '').replace('array_', '');
                    Object.keys(attributeValues).forEach(attributeValue => {
                        let attributeValueResult = false;
                        if (typeof this.lastSearchParams.attributes == 'object') {
                            if (typeof this.lastSearchParams.attributes[attributeType] == 'object') {
                                attributeValueResult = this.lastSearchParams.attributes[attributeType].indexOf(attributeValue) !== -1;
                            } else {
                                attributeValueResult = this.lastSearchParams.attributes[attributeType] == attributeValue;
                            }
                        }

                        result[attributeType][attributeValue] = attributeValueResult;
                        Vue.set(this.attributesDrawers, attributeType, false);
                    });
                });
                return result;
            },
            validAttributes() {
                let result = {};

                Object.keys(this.attributes).forEach(key => {
                    let attributeValues = this.attributes[key];

                    Object.keys(attributeValues).forEach(name => {
                        let value = attributeValues[name];

                        if (name.length > 0 && value) {
                            if (!result[key]) {
                                result[key] = {};
                            }

                            result[key][name] = value;
                        }
                    });
                });

                return result;
            },
            selectedFiltersLists() {
                let result = {};

                Object.keys(this.attributes).forEach(attributeType => {
                    let attributeValues = this.attributes[attributeType];
                    if (!result[attributeType]) {
                        result[attributeType] = {};
                    }

                    Object.keys(attributeValues).forEach(name => {
                        if (this.filtersStatus[attributeType][name]) {
                            result[attributeType][name] = true;
                        }
                    });
                });

                return result;
            },
        },
        methods: {
            getAttributeName: function (attributeType) {
                let name = attributeType;
                let attribute = this.getAttributeByIndexname(attributeType);
                if (attribute && attribute.name) {
                    name = attribute.name;
                }

                return name;
            },
            setAttributeValue: async function (attributeType, attributeValue, value) {
                attributeValue = attributeValue.replace(/\//g, '::');
                if (value) {
                    this.$router.push({
                        path: this.$search.getSearchRouteParams({
                            attributes: {
                                [attributeType]: [attributeValue]
                            }
                        }, false, true)
                    });
                } else {
                    let attributes = this.$router.currentRoute.params.attributes;
                    if (attributes && attributes[attributeType] != undefined && Array.isArray(attributes[attributeType])) {
                        if (attributes[attributeType].indexOf(attributeValue) != -1) {
                            attributes[attributeType].splice(attributes[attributeType].indexOf(attributeValue), 1);
                        }
                        this.$router.push({
                            path: this.$search.getSearchRouteParams({
                                attributes: {
                                    [attributeType]: Object.values(attributes[attributeType])
                                }
                            })
                        });
                    }
                }
            },
            getAttributeTypeIcon(indexname) {
                const attribute = this.getAttributeByIndexname(indexname);
                return attribute ? attribute.icon : '';
            },
            openDrawer(attributeType) {
                this.attributesDrawers[attributeType] = true;
                this.$emit('update:internalDrawerState', true);
            },
            closeDrawer(attributeType) {
                this.attributesDrawers[attributeType] = false;
                this.$emit('update:internalDrawerState', false);
            },
        },
        watch: {
            validAttributes: {
                immediate: true,
                handler(value) {
                    Object.keys(value).forEach((attributeType, i) => {
                        Vue.set(
                            this.expanded,
                            i,
                            Object.values(this.selectedFiltersLists[attributeType]).length > 0 || this.opened[attributeType]
                        );
                    });
                },
            },
            expanded(values) {
                values.forEach((k, i) => {
                    this.opened[Object.keys(this.validAttributes)[i]] = k;
                });
            },
      },
    };
</script>